import React, { useState } from 'react'

export default function CustomNote(props) {
  const { data } = props
  // const [isShow, setIsShow] = useState(true)

  return (
    <div>
      <span
        style={{ color: 'orange', cursor: 'pointer' }}
        // onClick={() => {
        //   setIsShow(!isShow)
        // }}
      >
        <b>
          <i>{data.title || 'หมายเหตุ : '}</i>
        </b>
      </span>
      {data.details && (
        <ul>
          {data.details.map((item) => {
            return (
              <li>
                <i>
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </i>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
